const playWhenVisible = function(item, slider){
	const Obs = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if(!entry.isIntersecting){
				slider.pause();
			}
			else {
				slider.play();
			}
		});
	}, {
		root: null,
		rootMargin: '0px',
		threshold: 0.3
	});
	Obs.observe($(item).closest('.tns-outer')[0]);
};

$(document).ready(() => {

	const setVh = () =>{
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
	setVh();

	let resizeTimeout;

	const resize = () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			setVh();
		}, 150);
	}

	window.addEventListener('resize', resize);
	window.addEventListener('orientationchange', resize);
	window.addEventListener('scroll', resize);


	let lastHeight = window.innerHeight;
	const monitorHeight = () => {
		const currentHeight = window.innerHeight;
		if (currentHeight !== lastHeight) {
			lastHeight = currentHeight;
			setVh();
		}
		requestAnimationFrame(monitorHeight);
	};
	monitorHeight();


	const $body = $('body');

	$(window).scroll(function () {
		if ($(window).scrollTop() > 1) {
			$("#header").addClass("fixed");
		} else {
			$("#header").removeClass("fixed");
		}
	});

	$('.mobile-menu-open').click(function(){
		$('#header nav').addClass('open');
		$body.addClass('disable-scroll');
	})
	$('.mobile-menu-close').click(function(){
		$('#header nav').removeClass('open');
		$body.removeClass('disable-scroll');
	})


	const media = window.matchMedia("(max-width: 832px)");
	mobileSupport(media);
	media.addEventListener('change', mobileSupport);

});
$.isMobile = false;
const mobileSupport = (media) => {
	if (media.matches) {
		$.isMobile = true;
		$(document).trigger("mobileOn");
	} else {
		$.isMobile = false;

		$(document).trigger("mobileOff");
	}
};
